import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'
import { MULTILOCATION } from '@/utils/roles'

export default {
  loginJWT({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/auth/login', payload.userDetails)
        .then(function(response) {
          if (response.data.user) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.access_token)

            // Update user details
            commit('SET_USER_INFO', response.data.user)
            commit('SET_PARENT_USER_INFO', response.data.parentUser)
            commit('SET_PERMISSIONS', response.data.permissions)
            commit('SET_GROWER_AND_PROCESSOR_ROLE_GROUP', response.data.growerAndProcessorRoleGroup)

            // Set bearer token in axios
            commit('SET_BEARER', response.data.access_token)

            if (response.data.user.roleId === MULTILOCATION) {
              localStorage.setItem('logInAsMultiLocationUser', true)
              localStorage.setItem('MultiLocationUser', response.data.user.id)
            } else if (localStorage.getItem('logInAsMultiLocationUser') === 'true' && response.data.user.roleId !== MULTILOCATION) {
              localStorage.setItem('logInAsMultiLocationUser', false)
            }

            dispatch('user/getBookmarkedNavs', true, { root: true })

            resolve(response)
          } else {
            reject({ message: 'Wrong Email or Password' })
          }
        })
        .catch(function(error) {
          reject((error.response && error.response.data) || { message: error.message })
        })
    })
  },
  logOut() {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('logInAsMultiLocationUser')
    localStorage.removeItem('MultiLocationUser')
    localStorage.removeItem('_expiredTime')
    localStorage.removeItem('selectedBookMarks')
  },
  async signInAs(_, id) {
    try {
      const { data } = await axios.get(`multi-location-user/${id}/generateToken`)
      return data
    } catch (err) {
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  validateUser: async (_, payload) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const { confirmPassword, ...data } = payload
      const res = await axios.post('/auth/validate-user', data)
      return { message: res.data.message }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  registerPaidUser: async ({ commit }, payload) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const { confirmPassword, ...data } = payload
      const res = await axios.post('/auth/signup', data)
      const { user, access_token, permissions } = res.data.data
      commit('SET_USER_INFO', user)
      commit('SET_PERMISSIONS', permissions)
      localStorage.setItem('accessToken', access_token)
      commit('SET_BEARER', access_token)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  registerUnpaidUser: async ({ commit }, payload) => {
    try {
      const res = await axios.post('/auth/create-marketplaceuser', payload)
      const { user, permissions, access_token } = res.data.data
      commit('SET_USER_INFO', user)
      commit('SET_PERMISSIONS', permissions)
      localStorage.setItem('accessToken', access_token)
      commit('SET_BEARER', access_token)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getBrainTreeClientToken: () => {
    return new Promise((resolve, reject) => {
      axios
        .get('/auth/get-braintree-client-token')
        .then(res => {
          resolve({
            data: res.data.data
          })
        })
        .catch(err => {
          reject({
            message: err.response.data.message
          })
        })
    })
  },
  updateProfile: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/auth/profile', payload)
        .then(res => {
          commit('SET_USER_INFO', res.data.data)
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          const { message } = getMessageFromError(err)
          reject({
            message
          })
        })
    })
  },
  changePassword: (_, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/auth/change-password', payload)
        .then(res => {
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          reject({
            errors: err.response.data.meta,
            message: err.response.data.message
          })
        })
    })
  },
  forgotPassword: async ({ commit }, payload) => {
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      commit('SET_STATE', {
        action: 'username',
        data: payload.username
      })
      const { data } = await axios.post('/auth/send-otp', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return { message: data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  restorePassword: async ({ commit }, payload) => {
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      commit('SET_STATE', {
        action: 'username',
        data: ''
      })
      const { data } = await axios.put('/auth/forget-password', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  }
}
